import { render } from "./ProductGallery.vue?vue&type=template&id=61ce7d9e&scoped=true"
import script from "./ProductGallery.js?vue&type=script&lang=js"
export * from "./ProductGallery.js?vue&type=script&lang=js"

import "./ProductGallery.scss?vue&type=style&index=0&id=61ce7d9e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ce7d9e"]])

export default __exports__